import Skeleton from "react-loading-skeleton";

export function AcuityHeaderSkeleton() {
  return (
    <div className="tw:flex tw:flex-col tw:gap-y-2 tw:leading-1">
      <Skeleton height={25} width={160} />
      <Skeleton height={20} width={140} />
    </div>
  );
}
